// Who may open a person's page. Profiles (/people/:id) and athlete pages
// (/athletes/:id) both used to require only a login, so any member with a link
// could read another member's — or another family's child's — contact details,
// purchases and sessions. Both now share this list, so they cannot drift.
//
// A screen, not a security boundary: the users and athletes read rules are
// still any signed-in account.

// The staff roles App.js routes to the staff start page.
export const PROFILE_STAFF_ROLES = ['admin', 'coach', 'assistant_coach', 'tournament_admin', 'court_admin', 'member_manager'];

export function isStaffRoles(roles) {
  return (roles || []).some(r => PROFILE_STAFF_ROLES.includes(r));
}
